export default {
  shouldTransition: true,
};
